import { render, staticRenderFns } from "./corner1.vue?vue&type=template&id=38119d54&scoped=true&"
import script from "./corner1.vue?vue&type=script&lang=js&"
export * from "./corner1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38119d54",
  null
  
)

export default component.exports